// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4a27fddd","147":"f62c9027","532":"8181cf05","574":"6c85020d","615":"9e06b21d","807":"8b5f9585","818":"026b181f","899":"16db47fd","900":"815301c4"}[chunkId] + ".chunk.js";
};